import React from 'react';
import { AlertCircle, Phone } from 'lucide-react';

const EmergencyWarning = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="rounded-xl p-4 flex items-start gap-3" style={{ backgroundColor: '#FEE2E2', border: '2px solid #DC2626' }}>
        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-black text-red-800" style={{ fontFamily: 'Merriweather, serif' }}>Emergency?</p>
          <p className="text-red-700 font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
            Call <a href="tel:911" className="font-black underline">911</a> for chest pain, difficulty breathing, or severe symptoms.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="rounded-2xl p-6 md:p-8"
      style={{ backgroundColor: '#FEE2E2', border: '3px solid #DC2626' }}
      data-testid="emergency-warning"
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Emergency Image */}
        <div className="hidden lg:block">
          <img 
            src="https://customer-assets.emergentagent.com/job_wellness-telecare/artifacts/ie22izku_4mzHe8OU8z4oSvwRxBpDF.png"
            alt="Emergency symptoms - chest pain"
            className="rounded-xl w-full h-full object-cover"
          />
        </div>
        
        {/* Emergency Content */}
        <div className="lg:col-span-2">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FCA5A5' }}>
              <AlertCircle className="w-7 h-7 text-red-700" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl lg:text-2xl font-black text-red-800 mb-3" style={{ fontFamily: 'Merriweather, serif' }}>
                ⚠️ EMERGENCY WARNING
              </h3>
              <p className="text-red-700 mb-4 font-bold text-lg" style={{ fontFamily: 'Merriweather, serif' }}>
                If you are experiencing a life-threatening emergency, <strong>DO NOT</strong> use this service.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white/50 p-4 rounded-xl">
                  <p className="font-black text-red-800 mb-2" style={{ fontFamily: 'Merriweather, serif' }}>Call 911 or go to the ER immediately for:</p>
                  <ul className="text-sm text-red-700 space-y-1 font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                    <li>• Chest pain or pressure</li>
                    <li>• Difficulty breathing</li>
                    <li>• Severe bleeding</li>
                    <li>• Signs of stroke (face drooping, arm weakness, speech difficulty)</li>
                    <li>• Loss of consciousness</li>
                    <li>• Severe allergic reactions</li>
                    <li>• Serious injuries or trauma</li>
                  </ul>
                </div>
                <div className="bg-white/50 p-4 rounded-xl">
                  <p className="font-black text-red-800 mb-2" style={{ fontFamily: 'Merriweather, serif' }}>Our urgent care IS appropriate for:</p>
                  <ul className="text-sm text-red-700 space-y-1 font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                    <li>• Cold & flu symptoms</li>
                    <li>• Minor injuries & cuts</li>
                    <li>• Urinary tract infections</li>
                    <li>• Skin rashes & infections</li>
                    <li>• Ear & sinus infections</li>
                    <li>• Medication refills</li>
                    <li>• Lab result discussions</li>
                  </ul>
                </div>
              </div>

              <div className="flex items-center gap-4 pt-4 border-t-2 border-red-300">
                <a 
                  href="tel:911" 
                  className="inline-flex items-center gap-2 text-white px-8 py-3 rounded-lg font-black text-lg transition-all shadow-lg"
                  style={{ 
                    background: 'linear-gradient(to right, #DC2626, #B91C1C)',
                    fontFamily: 'Merriweather, serif'
                  }}
                >
                  <Phone className="w-5 h-5" />
                  Call 911
                </a>
                <span className="text-sm text-red-700 font-bold" style={{ fontFamily: 'Merriweather, serif' }}>
                  For emergencies only
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyWarning;
